
import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-empty-products-establishment',
  imports: [],
  templateUrl: './empty-products-establishment.component.html',
  styleUrl: './empty-products-establishment.component.css'
})
export class EmptyProductsEstablishmentComponent {
  @Input() loading: boolean = false;
}
